import React from "react";
import SiteShell from "../site/SiteShell";
import Hero from "../site/Hero";
import TwoSides from "../site/TwoSides";
import ClientMarquee from "../site/ClientMarquee";
import VWModel from "../site/VWModel";
import HomeCTA from "../site/HomeCTA";

export default function Home() {
  return (
    <SiteShell>
      <Hero />
      <TwoSides />
      <ClientMarquee />
      <VWModel />
      <HomeCTA />
    </SiteShell>
  );
}
